/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Editable PAM player profile fields (PATCH details). Omitted fields are left unchanged.
 * dob is ISO YYYY-MM-DD; ssn4 is the last four digits of the SSN.
 * @export
 * @interface PlayerDetailsEditRequest
 */
export interface PlayerDetailsEditRequest {
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    ssn4?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    dob?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDetailsEditRequest
     */
    firstName?: string;
}

/**
 * Check if a given object implements the PlayerDetailsEditRequest interface.
 */
export function instanceOfPlayerDetailsEditRequest(value: object): value is PlayerDetailsEditRequest {
    return true;
}

export function PlayerDetailsEditRequestFromJSON(json: any): PlayerDetailsEditRequest {
    return PlayerDetailsEditRequestFromJSONTyped(json, false);
}

export function PlayerDetailsEditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerDetailsEditRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ssn4': json['ssn4'] == null ? undefined : json['ssn4'],
        'dob': json['dob'] == null ? undefined : json['dob'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'region': json['region'] == null ? undefined : json['region'],
        'city': json['city'] == null ? undefined : json['city'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'address': json['address'] == null ? undefined : json['address'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
    };
}

export function PlayerDetailsEditRequestToJSON(value?: PlayerDetailsEditRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ssn4': value['ssn4'],
        'dob': value['dob'],
        'postalCode': value['postalCode'],
        'region': value['region'],
        'city': value['city'],
        'addressLine2': value['addressLine2'],
        'address': value['address'],
        'phone': value['phone'],
        'email': value['email'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
    };
}

